module.exports = __webpack_public_path__ + "img/Rewind.d83605af.svg";